(() => {
  const setup = (section) => {
    if (section.dataset.brioVideoReady) return;
    const video = section.querySelector('.brio-hero-video');
    const media = section.querySelector('.brio-hero-video-media');
    if (!video || !media) return;
    section.dataset.brioVideoReady = 'true';
    video.muted = true;
    video.defaultMuted = true;

    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    let inView = false;
    let firstFrameShown = false;
    let frameRequested = false;
    const revealFirstFrame = () => {
      if (firstFrameShown || frameRequested || video.readyState < HTMLMediaElement.HAVE_CURRENT_DATA) return;
      frameRequested = true;
      const reveal = () => {
        if (firstFrameShown || video.paused || document.hidden) {
          frameRequested = false;
          return;
        }
        firstFrameShown = true;
        media.classList.add('is-playing');
      };
      if ('requestVideoFrameCallback' in video) video.requestVideoFrameCallback(reveal);
      else requestAnimationFrame(() => requestAnimationFrame(reveal));
    };
    const syncPlayback = () => {
      if (reducedMotion.matches || document.hidden || !inView) {
        video.pause();
        return;
      }
      video.play().catch(() => {
        media.classList.remove('is-playing');
      });
    };

    video.addEventListener('playing', revealFirstFrame);
    video.addEventListener('loadeddata', revealFirstFrame);
    video.addEventListener('error', () => { if (!firstFrameShown) media.classList.remove('is-playing'); });
    reducedMotion.addEventListener('change', syncPlayback);
    document.addEventListener('visibilitychange', syncPlayback);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        inView = entries[0]?.isIntersecting ?? false;
        syncPlayback();
      }, { threshold: 0.1 }).observe(section);
    } else {
      inView = true;
      syncPlayback();
    }
  };

  const start = () => document.querySelectorAll('.brio-hero-layered--video').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();
